export const TIMER_DETAIL_HEIGHT = 64
export const PAUSED_TIMER_HEADER_HEIGHT = 34

export const OTHER_TIMERS_HEADER_HEIGHT = 48
export const OTHER_TIMERS_ROW_HEIGHT = 60
